export default {
  active: 'Active',
  inactive: 'Inactive',
  pending: 'Pending',
  inProgress: 'In Progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
  bizOrder: {
    DRAFT: 'Draft',
    PENDING: 'Pending Booking',
    PENDING_BOOKING: 'Pending Booking',
    PENDING_MATCH: 'Pending Match',
    SUBMITTED: 'Submitted',
    MATCHED: 'Matched',
    TRACKING: 'Tracking',
    WAREHOUSED: 'Warehoused',
    LOCKED: 'Locked',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    PENDING_VIEWED: 'Pending Booking (Route Viewed)',
    PENDING_UNVIEWED: 'Pending Booking (Route Unviewed)',
  },
  bizOrderTab: {
    DRAFT: 'Draft Box',
    PENDING: 'Pending Booking',
    TRACKING: 'Tracking',
    LOCKED: 'Locked',
  },
  productOrder: {
    DRAFT: 'Draft',
    PRE_BOOKED: 'Pre-booked',
    PREBOOKED: 'Pre-booked',
    MATCHED: 'Matched',
    LOCKED: 'Locked',
    IN_TRANSIT: 'In Transit',
    EXECUTING: 'Executing',
    ARRIVED: 'Arrived',
    ALERT: 'Alert',
    ARCHIVED: 'Archived',
    DISSOLVED: 'Dissolved',
    COMPLETED: 'Completed',
  },
  hawb: {
    DRAFT: 'Draft',
    CONFIRMED: 'Confirmed',
    ISSUED: 'Issued',
    VOID: 'Void',
  },
  agreement: {
    ACTIVE: 'Active',
    OVERSOLD: 'Oversold',
    EXPIRED: 'Inactive',
  },
  paymentStatus: {
    PAID: 'Received',
    PARTIAL: 'Partial',
    UNPAID: 'Unreceived',
  },
  payStatus: {
    PAID: 'Paid',
    UNPAID: 'Unpaid',
  },
  changeRequest: {
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
  },
}
